// Vendor Libs
import React, {useContext, useState} from 'react';

// Material UI
import {AppBar, Toolbar, Typography} from '@material-ui/core';

// Dish Tech React
import {Logout} from '@dishtech-react/core';
import {RouteContext} from '../contexts/route-context';

// Images
import logo from '../assets/logo.svg';

interface ILayoutProps {
  children: React.ReactNode;
}

export default ({children}: ILayoutProps) => {
  const routeContext = useContext(RouteContext);
  const [isLogoutOpen, setLogoutOpen] = useState(false);
  return (
    <div className="app">
      <AppBar color="primary">
        <Toolbar>
          <Typography style={{flexGrow: 1, display: 'flex', alignItems: 'center'}}>
            <img alt="Dish Netowork" src={logo} width={75} />
            <span style={{marginLeft: 20}}>Cloud Whitelist Management</span>
          </Typography>
          <Logout
            isLogoutOpen={isLogoutOpen}
            routeContext={routeContext}
            setLogoutOpen={setLogoutOpen}
            showIcon={true}
            textCaseUpper={false}
          />
        </Toolbar>
      </AppBar>
      <main>{children}</main>
    </div>
  );
};
